import moment, { Moment } from "moment";

export type RoadDateRange = {
  from?: Date;
  to?: Date;
};

export type RoadDateValue = Moment | Date | string | RoadDateRange | null | undefined;

const isRoadDateRange = (date: RoadDateValue): date is RoadDateRange => {
  return Boolean(
    date &&
    typeof date === "object" &&
    !moment.isMoment(date) &&
    ("from" in date || "to" in date)
  );
};

export const getRoadDepartureMoment = (date: RoadDateValue): Moment | undefined => {
  if (!date) return undefined;

  if (isRoadDateRange(date) && date.from) {
    return moment(date.from);
  }

  if (moment.isMoment(date)) {
    const originalInput = (date as any)._i;

    if (originalInput?.from) {
      return moment(originalInput.from);
    }

    return date;
  }

  return moment(date as moment.MomentInput);
};

export const getRoadReturnMoment = (
  departureDate: RoadDateValue,
  arrivalDate?: RoadDateValue,
): Moment | undefined => {
  if (isRoadDateRange(departureDate) && departureDate.to) {
    return moment(departureDate.to);
  }

  if (moment.isMoment(departureDate)) {
    const originalInput = (departureDate as any)._i;

    if (originalInput?.to) {
      return moment(originalInput.to);
    }
  }

  if (arrivalDate) return getRoadDepartureMoment(arrivalDate);

  return undefined;
};

export const formatRoadDate = (date: RoadDateValue, format = "ddd, MMM D") => {
  return getRoadDepartureMoment(date)?.format(format) || "";
};

export const formatRoadDateRange = (
  departureDate: RoadDateValue,
  arrivalDate?: RoadDateValue,
  format = "ddd, MMM D",
) => {
  const departure = getRoadDepartureMoment(departureDate);
  const arrival = getRoadReturnMoment(departureDate, arrivalDate);

  if (departure && arrival) {
    return `${departure.format(format)} - ${arrival.format(format)}`;
  }

  return departure?.format(format) || "";
};